<template>
    <v-card class="text-xs-center">
        <v-dialog v-model="dialog" max-width="500" persistent>
            <v-card class="text-xs-center">
                <v-card-title class="subheading justify-center">You've Successfully Confirmed Your Email Address</v-card-title>
                <v-btn color="purple" dark href="/">go to login</v-btn>
            </v-card>
        </v-dialog>
        <v-dialog v-model="errorDialog" max-width="350">
            <v-card>
                <v-card-title>{{errorMsg}}</v-card-title>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import axios from "axios";
export default{
    name: 'Verify',
    data: ()=>({
        token: '',
        errorDialog: false,
        dialog: true,
        errorMsg: "IDK why do u see this window"
    }),
    created(){
        this.token = this.$route.params.verify_token
        axios.get(`${this.$hostname}/client/verify/${this.token}`)
        .then(response => {
            console.log(response)
        })
        .catch(error => {
            this.errorDialog = true
            this.errorMsg = `${this.$store.getters.errorsList[error.response.data.message]}`
        });
    }
}
</script>
<style scope lang="scss">
</style>